/* ============================================================
   Casandra Brunelli — JS propio (vanilla, sin librerias)
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal al hacer scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.cb-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cb-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cb-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- parallax suave del hero ---------- */
  function initParallax() {
    if (reduceMotion) return;
    var layers = document.querySelectorAll('[data-cb-parallax]');
    if (!layers.length) return;
    var ticking = false;
    function update() {
      layers.forEach(function (layer) {
        var rect = layer.parentElement.getBoundingClientRect();
        var speed = parseFloat(layer.getAttribute('data-cb-parallax')) || 0.15;
        var offset = (rect.top + rect.height / 2 - window.innerHeight / 2) * -speed;
        layer.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0) scale(1.12)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- galeria de la pagina de producto ---------- */
  function cbKey(url) { return (url || '').split('?')[0].split('/').pop().replace(/_\d+x\d*(?=\.)/, '').replace(/_\d*x\d+(?=\.)/, ''); }
  window.cbSlideTo = function (img) {
    var track = document.querySelector('[data-cb-track]');
    if (!track || !img) return false;
    var key = cbKey(img);
    var slides = track.querySelectorAll('[data-cb-slide]');
    for (var i = 0; i < slides.length; i++) {
      if (cbKey(slides[i].getAttribute('data-key')) === key || cbKey(slides[i].currentSrc || slides[i].src) === key) {
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
        return true;
      }
    }
    return false;
  };
  function initGallery() {
    var track = document.querySelector('[data-cb-track]');
    var dots = document.querySelectorAll('[data-cb-dot]');
    if (track && dots.length) {
      var setDot = function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      };
      track.addEventListener('scroll', function () { window.requestAnimationFrame(setDot); }, { passive: true });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var i = parseInt(d.getAttribute('data-cb-dot'), 10);
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        });
      });
    }
    var gallery = document.querySelector('[data-cb-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-cb-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-cb-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full');
        var alt = thumb.getAttribute('data-alt') || '';
        if (src) { main.src = src; main.alt = alt; }
        thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ---------- selector de variantes ---------- */
  function initVariants() {
    var root = document.querySelector('[data-cb-product]');
    if (!root) return;
    var dataEl = root.querySelector('[data-cb-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[data-cb-variant-id]');
    var priceEl = root.querySelector('[data-cb-price]');
    var addBtn = root.querySelector('[data-cb-add]');
    var lowStockEl = root.querySelector('[data-cb-lowstock]');
    var lowStockThreshold = lowStockEl ? parseInt(lowStockEl.getAttribute('data-threshold'), 10) : 0;
    var lowStockBefore = lowStockEl ? lowStockEl.getAttribute('data-before') : '';
    var lowStockAfter = lowStockEl ? lowStockEl.getAttribute('data-after') : '';
    var addLabel = addBtn ? addBtn.getAttribute('data-label-add') : '';
    var soldLabel = addBtn ? addBtn.getAttribute('data-label-sold') : '';
    var moneyFormat = root.getAttribute('data-money-format') || '{{amount}}';
    var selected = {};

    root.querySelectorAll('[data-cb-option-index]').forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-cb-option-index'), 10);
      var pressed = group.querySelector('[aria-pressed="true"]');
      if (pressed) selected[idx] = pressed.getAttribute('data-value');
      group.querySelectorAll('.cb-pdp__swatch').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('.cb-pdp__swatch').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          selected[idx] = btn.getAttribute('data-value');
          // Color: nombre junto al título ("Colore — Blu") y foto grande de ese color
          var label = group.querySelector('[data-cb-opt-selected]');
          if (label) label.textContent = selected[idx];
          var img = btn.getAttribute('data-img');
          var main = root.querySelector('[data-cb-gallery-main]');
          if (img && !(window.cbSlideTo && window.cbSlideTo(img)) && main) { main.src = img; main.alt = selected[idx]; var tr = root.querySelector('[data-cb-track]'); if (tr) tr.scrollTo({ left: 0, behavior: 'smooth' }); }
          resolve();
        });
      });
    });

    function formatMoney(cents) {
      var value = (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return moneyFormat.replace(/\{\{\s*amount[\w]*\s*\}\}/, value);
    }

    function resolve() {
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i] === undefined || selected[i] === opt; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) {
        var html = '';
        var onSale = match.compare_at_price && match.compare_at_price > match.price;
        if (onSale) {
          var pct = Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price);
          html = '<span class="cb-pdp__sale">' + formatMoney(match.price) + '</span> <s class="cb-pdp__compare">' + formatMoney(match.compare_at_price) + '</s> <span class="cb-pdp__badge">Saldi per trasloco!</span>';
        } else {
          html = '<span class="cb-pdp__regular">' + formatMoney(match.price) + '</span>';
        }
        priceEl.innerHTML = html;
        priceEl.classList.toggle('cb-pdp__price--sale', !!onSale);
      }
      if (addBtn) {
        if (match.available) { addBtn.disabled = false; addBtn.textContent = addLabel; }
        else { addBtn.disabled = true; addBtn.textContent = soldLabel; }
      }
      if (lowStockEl) {
        var qty = match.inventory_quantity;
        var tracked = match.inventory_management === 'shopify';
        if (tracked && qty > 0 && qty <= lowStockThreshold) {
          lowStockEl.textContent = lowStockBefore + ' ' + qty + ' ' + lowStockAfter;
          lowStockEl.hidden = false;
        } else {
          lowStockEl.hidden = true;
        }
      }
    }
  }

  /* ---------- barra de progreso de scroll ---------- */
  function initScrollBar() {
    if (reduceMotion) return;
    var bar = document.createElement('div');
    bar.className = 'cb-scrollbar';
    document.body.appendChild(bar);
    var ticking = false;
    function update() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var pct = h > 0 ? (window.scrollY / h) * 100 : 0;
      bar.style.width = pct.toFixed(2) + '%';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- carrusel de reseñas: tarjeta central destacada, puntos y avance automático ---------- */
  function initReviewsCarousel() {
    document.querySelectorAll('[data-cb-testi]').forEach(function (track) {
      var cards = Array.prototype.slice.call(track.querySelectorAll('.cb-pdp__review'));
      if (!cards.length) return;
      var dotsBox = track.parentElement.querySelector('[data-cb-testi-dots]');
      var dots = [];
      var active = -1;

      function centerOf(i) { var c = cards[i]; return c.offsetLeft + c.offsetWidth / 2 - track.clientWidth / 2; }
      function go(i) { track.scrollTo({ left: centerOf(i), behavior: reduceMotion ? 'auto' : 'smooth' }); }
      function update() {
        var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bestD = Infinity;
        cards.forEach(function (c, i) {
          var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid);
          if (d < bestD) { bestD = d; best = i; }
        });
        if (best === active) return;
        active = best;
        cards.forEach(function (c, i) { c.classList.toggle('is-active', i === best); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === best); });
      }

      if (dotsBox) {
        cards.forEach(function (c, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'cb-testi__dot';
          b.setAttribute('aria-label', 'Recensione ' + (i + 1));
          b.addEventListener('click', function () { go(i); });
          dotsBox.appendChild(b);
          dots.push(b);
        });
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (!ticking) { window.requestAnimationFrame(function () { update(); ticking = false; }); ticking = true; }
      }, { passive: true });
      window.addEventListener('resize', update);
      update();

      if (reduceMotion) return;
      var paused = false;
      track.addEventListener('mouseenter', function () { paused = true; });
      track.addEventListener('mouseleave', function () { paused = false; });
      track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      setInterval(function () {
        if (paused || document.hidden) return;
        go((active + 1) % cards.length);
      }, 4500);
    });
  }

  /* ---------- cuenta atrás decorativa del cajón del carrito ----------
     Cuenta desde 10:00 y vuelve a empezar en bucle. No representa una reserva real ni el final
     de ninguna oferta real (eso sería un contador de escasez falso) - es solo un adorno visual
     de marca, con un texto configurable desde Ajustes del tema. */
  function initCartCountdown() {
    function pad(n) { return String(n).padStart(2, '0'); }
    var secondsLeft = 600;
    setInterval(function () {
      var box = document.querySelector('[data-cb-cart-countdown]');
      if (!box) return;
      secondsLeft -= 1;
      if (secondsLeft < 0) secondsLeft = 600;
      var mm = pad(Math.floor(secondsLeft / 60)), ss = pad(secondsLeft % 60);
      // Formato simple en una línea ("09:38")
      var both = box.querySelector('[data-cb-cart-mmss]');
      if (both) { both.textContent = mm + ':' + ss; return; }
      // Formato antiguo (cajas de minutos y segundos)
      var m = box.querySelector('[data-cb-cart-m]');
      var s = box.querySelector('[data-cb-cart-s]');
      if (m && s) { m.textContent = mm; s.textContent = ss; }
    }, 1000);
  }

  /* ---------- botón "Scopri la nostra storia": abre el desplegable "Chi siamo"
     del pie de página y hace scroll suave hasta él ---------- */
  function initOpenAbout() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-open-about]');
      if (!trigger) return;
      var details = document.getElementById('cb-footer-about');
      if (!details) return;
      e.preventDefault();
      details.open = true;
      details.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---------- añadir al carrito con el cajón lateral de Impulse ----------
     Sin JS (o con carrito en página) el formulario se envía normal a /cart/add. */
  function initAjaxCart() {
    if (!window.theme || !theme.AjaxProduct || !theme.settings || theme.settings.cartType !== 'drawer') return;
    document.querySelectorAll('form[data-cb-ajax-form]').forEach(function (form) {
      new theme.AjaxProduct(form, '.cb-pdp__add');
    });
  }

  /* ---------- protección de envío en el cajón del carrito ----------
     Interruptor DESACTIVADO por defecto: al activarlo añade 1 unidad del producto de protección,
     al desactivarlo la quita. Nunca más de 1, y si en el carrito solo queda la protección se quita
     sola (no se cobra un servicio sin pedido). */
  function initProtection() {
    var box = document.querySelector('[data-cb-protection]');
    if (!box || !window.fetch) return;
    var toggle = box.querySelector('[data-cb-protection-toggle]');
    var variantId = parseInt(box.getAttribute('data-variant-id'), 10);
    var routes = (window.theme && theme.routes) || {};
    var addUrl = routes.cartAdd || '/cart/add.js';
    var changeUrl = routes.cartChange || '/cart/change.js';
    var busy = false;

    function post(url, body) {
      return fetch(url, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    function rebuild() { document.dispatchEvent(new CustomEvent('cart:build')); }
    function run(promise, onError) {
      busy = true;
      box.classList.add('is-loading');
      return promise.catch(onError || function () {}).then(function () {
        busy = false;
        box.classList.remove('is-loading');
        rebuild();
      });
    }

    toggle.addEventListener('change', function () {
      if (busy) return;
      var on = toggle.checked;
      run(on ? post(addUrl, { items: [{ id: variantId, quantity: 1 }] })
             : post(changeUrl, { id: String(variantId), quantity: 0 }), // change.js exige el id como texto
          function () { toggle.checked = !on; });
    });

    // Tras cada reconstrucción del carrito: sincronizar el interruptor y corregir casos raros
    var products = document.querySelector('#CartDrawer [data-products]');
    if (!products) return;
    new MutationObserver(function () {
      var items = products.querySelector('.cart__items');
      if (!items || busy) return;
      var qty = parseInt(items.getAttribute('data-cb-protection-qty') || '0', 10);
      var count = parseInt(items.getAttribute('data-count') || '0', 10);
      var key = items.getAttribute('data-cb-protection-key');
      toggle.checked = qty > 0;
      if (qty > 0 && count === 0) {
        run(post(changeUrl, { id: key, quantity: 0 }));
      } else if (qty > 1) {
        run(post(changeUrl, { id: key, quantity: 1 }));
      }
    }).observe(products, { childList: true });
  }

  /* ---------- tallas y colores en fila deslizable, con flechas si no caben ---------- */
  function initSwatchSliders() {
    document.querySelectorAll('[data-cb-swatch-slider]').forEach(function (wrap) {
      var track = wrap.querySelector('.cb-pdp__swatches');
      var prev = wrap.querySelector('.cb-pdp__swatches-arrow--prev');
      var next = wrap.querySelector('.cb-pdp__swatches-arrow--next');
      if (!track) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (prev) prev.hidden = track.scrollLeft <= 2;
        if (next) next.hidden = track.scrollLeft >= max - 2;
      }
      [prev, next].forEach(function (btn) {
        if (!btn) return;
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.getAttribute('data-dir'), 10);
          track.scrollBy({ left: dir * track.clientWidth * 0.7, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
      // Que la opción elegida quede a la vista
      var sel = track.querySelector('[aria-pressed="true"]');
      if (sel && sel.offsetLeft + sel.offsetWidth > track.clientWidth) track.scrollLeft = sel.offsetLeft - 8;
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- cajón del carrito: papelera sin recargar y "Carrello • N" ---------- */
  function initCartDrawerExtras() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cb-remove]');
      if (!btn || !window.theme || !theme.cart || !theme.cart.changeItem) return;
      e.preventDefault();
      var line = btn.closest('.cart__item');
      if (line) line.classList.add('is-loading');
      theme.cart.changeItem(btn.getAttribute('data-cb-remove'), 0).then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      }).catch(function () { window.location.href = btn.href; });
    });

    var products = document.querySelector('#CartDrawer [data-products]');
    var countEl = document.querySelector('[data-cb-cart-count]');
    if (!products || !countEl) return;
    new MutationObserver(function () {
      var items = products.querySelector('.cart__items');
      if (!items) return;
      var n = parseInt(items.getAttribute('data-count') || '0', 10);
      countEl.textContent = n;
      countEl.parentElement.hidden = n === 0;
    }).observe(products, { childList: true });
  }

  function boot() {
    initCartDrawerExtras();
    initSwatchSliders();
    initAjaxCart();
    initProtection();
    initReveal();
    initParallax();
    initGallery();
    initVariants();
    initScrollBar();
    initReviewsCarousel();
    initCartCountdown();
    initOpenAbout();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
